module.exports = __webpack_public_path__ + "media/images/emblems/Agno-coat_of_arms-cd8c7862fc9288ed8d4726127b433ce4.svg";